import React from 'react'
import { faArrowRotateRight } from '@fortawesome/pro-solid-svg-icons/faArrowRotateRight'
import { useTranslationRankmi } from 'helpers/translations.helper'
import {
  ErrorContentArea,
  ErrorDescription,
  ErrorFlagDisabledTitle,
  ErrorFooter,
  ErrorLayout,
} from './AiEvaluationModal.styled'
import {
  FooterActions,
  FooterCancelButton,
  FooterRegenerateButton,
  FooterRegenerateIcon,
  FooterRegenerateLabel,
  SaveAndConfigureButton,
} from './EvaluationPreview.styled'

type RecoverableErrorKind =
  | 'generationFailed'
  | 'noContent'
  | 'serviceUnavailable'
  | 'notConfigured'

interface Props {
  variant: 'flagDisabled' | 'recoverable'
  errorKind?: RecoverableErrorKind
  title?: string
  message?: string
  onCancel: () => void
  onRetry?: () => void
}

const EvaluationErrorContent: React.FC<Props> = ({
  variant,
  errorKind = 'generationFailed',
  title,
  message,
  onCancel,
  onRetry,
}) => {
  const tError = useTranslationRankmi({
    prefix: 'administration.blocks.aiEvaluation.generationErrorStep',
  })
  const tPreview = useTranslationRankmi({
    prefix: 'administration.blocks.aiEvaluation.previewModal',
  })
  const t = useTranslationRankmi({
    prefix: 'administration.blocks.aiEvaluation',
  })

  const recoverableMessage = tError(errorKind)

  return (
    <ErrorLayout>
      <ErrorContentArea>
        {variant === 'flagDisabled' && title ? (
          <>
            <ErrorFlagDisabledTitle>{title}</ErrorFlagDisabledTitle>
            <ErrorDescription>{message}</ErrorDescription>
          </>
        ) : (
          <ErrorDescription>{recoverableMessage}</ErrorDescription>
        )}
      </ErrorContentArea>

      <ErrorFooter>
        <FooterActions>
          {variant === 'recoverable' && (
            <FooterCancelButton
              type="button"
              data-test-id="button-ai-evaluation-error-cancel"
              onClick={onCancel}
            >
              {tPreview('cancel')}
            </FooterCancelButton>
          )}
          {variant === 'recoverable' ? (
            <FooterRegenerateButton
              type="button"
              data-test-id="button-ai-evaluation-error-retry"
              onClick={onRetry}
            >
              <FooterRegenerateIcon icon={faArrowRotateRight} aria-hidden />
              <FooterRegenerateLabel>
                {t('actions.retry')}
              </FooterRegenerateLabel>
            </FooterRegenerateButton>
          ) : (
            <SaveAndConfigureButton
              type="button"
              data-test-id="button-ai-evaluation-error-close"
              onClick={onCancel}
            >
              {tPreview('cancel')}
            </SaveAndConfigureButton>
          )}
        </FooterActions>
      </ErrorFooter>
    </ErrorLayout>
  )
}

export default EvaluationErrorContent
